import { useContext, useEffect } from 'react';
import { useUpdate } from '@bydesign-ui/hooks';
import { ColorContext } from '../context/color';
export function useColor() {
  var color = useContext(ColorContext);
  var update = useUpdate();

  if (color == null) {
    throw new Error('useColor must be use under RcColor');
  }

  useEffect(function () {
    color.addListener('repaint', update);
    return function () {
      return color.removeListener('repaint', update);
    };
  }, []);
  return color;
}